import _ from 'lodash';
import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import IMG from '../img';
import { useProvidersContext } from '../../contexts/providers';
import { useProviderDetailsContext } from '../../contexts/providerDetails';
import { findProviders } from '../../api/ecDataQueryApi';

const ProductWrapper = styled.div`
  width: 200px;
  display: inline-block;
  margin: 10px;
  padding: 10px;
  overflow: hidden;
  text-align: left;
  cursor: pointer;
  color: black;
  &:hover{
      opacity: 0.6;
  }
`;

const Image = styled(IMG)`
  width: 100%;
  height: 225px;
  object-fit: contain;
`;

const ImageUnprepared = styled(Skeleton)`
  width: 100%;
  height: 225px;
  display: inline-block;
`;

const TextUnprepared = styled(Skeleton)`
  width: 100%;
  height: 20px;
`;

const Title = styled.div`
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const BrandName = styled(Title)`
  font-weight: bold;
  color: black;
  &:hover{
    opacity: 0.6;
  }
`;

const PriceLineThrough = styled(Title)`
  text-decoration: line-through;
`;

const SellPrice = styled(Title)`
  color: red;
  float: right;
`;

export default ({ data, onClick }) => {
  const {
    name,
    providerKey,
    price,
    sellPrice,
    images,
  } = data || {};

  const {
    providers: providersCache,
    addProviders,
  } = useProvidersContext();
  const {
    providerDetails: providerDetailsCache,
  } = useProviderDetailsContext();

  const provider = useMemo(() => _.get(providersCache, [providerKey, 'name'], null)
    || _.get(providerDetailsCache, [providerKey, 'name'], null),
  [providerKey, providersCache, providerDetailsCache]);

  useEffect(() => {
    (async () => {
      try {
        if (!providerKey || provider || providersCache[providerKey]) return;
        addProviders(providerKey, {});
        const providersData = await findProviders(providerKey);
        providersData.forEach(({ key, value }) => {
          try {
            addProviders(key, JSON.parse(value));
          } catch (error) {
            console.error(error);
          }
        });
      } catch (error2) {
        console.error(error2);
      }
    })();
  }, [providerKey, provider, addProviders, providersCache]);

  const displayPrice = useMemo(() => (
    Math.max(...[price || ''].flat().filter((d, index) => index < 2)).toLocaleString('en-US')
  ), [price]);

  const displaySellPrice = useMemo(() => (
    _.uniq([sellPrice || ''].flat().filter((d, index) => index < 2)).map((d) => d.toLocaleString('en-US')).join('~')
  ), [sellPrice]);

  if (data === undefined) return <ProductWrapper />;
  if (!data || _.isEmpty(data)) {
    return (
      <ProductWrapper>
        <ImageUnprepared variant="rect" animation="wave" />
        <TextUnprepared variant="text" animation="wave" />
        <TextUnprepared variant="text" animation="wave" width="40%" />
        <TextUnprepared variant="text" animation="wave" />
      </ProductWrapper>
    );
  }
  return (
    <ProductWrapper onClick={onClick}>
      <Image src={_.get(images, [0], null)} />
      <Title>
        {name}
      </Title>
      <Link to={`/ec/search/${providerKey}`} onClick={onClick}>
        <BrandName>
          {
            (provider === null || provider === undefined)
              ? <TextUnprepared variant="text" animation="wave" width="40%" />
              : provider
          }
        </BrandName>
      </Link>
      {
        displaySellPrice === displayPrice ? (
          <Title>
            $
            {displayPrice}
          </Title>
        ) : (
          <>
            <SellPrice>
              $
              {displaySellPrice}
            </SellPrice>
            <PriceLineThrough>
              $
              {displayPrice}
            </PriceLineThrough>
          </>
        )
      }

    </ProductWrapper>
  );
};
